module.exports = __webpack_public_path__ + "static/media/Dance.7710342b.webp";